<template>
	<div style="padding: 10px 10px 10px 0;page-break-before: auto;page-break-after: always;">
		<el-dialog :visible.sync="show" width="700px" id="printTest" :before-close="handleClose">
			<div ref="print" style="margin-top:0px;padding: 0;">
				<div
					style="border-top: 1px solid #000000;border-bottom: 1px solid #000000;text-align: center;font-size: 24px;padding: 5px 0;">
					缴款通知书</div>
				<div>
					商品名称: {{ obj.shopName }}
				</div>
				<div>经营品牌: {{ obj.shopName }}</div>
				<div style="display: flex;justify-content: space-between;border-bottom: 1px solid #000000;">
					<div>商铺编号: {{ obj.shopNum }}</div>
					<div>合同号: {{ obj.number }}</div>
				</div>
				<div>尊敬的供应商:</div>
				<div style="margin: 5px 0;">
					&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;根据贵我双方租赁合同中的有关条款约定，请贵司按期将下列款项汇至本公司账户。
				</div>
				<div>户名: 江苏国际人才咨询服务有限公司</div>
				<div style="margin: 5px 0;">开 户 银 行: 中国银行江苏省分行营业部</div>
				<div>账号: 5092 6897 8348</div>
				<div style="margin:20px 0 0 30px;">谢谢合作!</div>
				<el-table :data="bdShopPayList" style="width: 100%" border>
					<el-table-column prop="type" label="款项类别"></el-table-column>
					<el-table-column prop="term" label="所属期限">

					</el-table-column>
					<el-table-column prop="appdate" label="最后缴款日">
						<template slot-scope="{row}">
							{{ row.appdate.split("T")[0] }}
						</template>
					</el-table-column>
					<el-table-column prop="money" label="应交金额(元)">
						<template slot-scope="scope">
							<span v-if="scope.row.editIs == '0'">
								{{ scope.row.money }}
							</span>
							<el-input v-else v-model="scope.row.money" placeholder="请输入金额"></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="remark" label="备注"></el-table-column>
					<el-table-column v-if="isDyxs" class="no-print" width="80" prop="remark" label="操作">
						<template slot-scope="scope">
							<el-button v-if="scope.row.editIs == '0'" type="primary" size="mini"
								@click="editShopPay(scope.row, scope.$index)">修改</el-button>
							<el-button v-else type="primary" size="mini"
								@click="saveShopPay(scope.row, scope.$index)">保存</el-button>

						</template>
					</el-table-column>
				</el-table>
				<!-- 	<div style="margin: 0 0 5px 10px;">备注:提成租金:第1年5%扣点。</div> -->
				<div style="margin: 0 0 0 15px;">电费:1元/度: 水费:按公共事业公布标准+10%的管理费</div>
				<div style="margin: 0 0 0 15px;">合计:{{ sum }}元</div>
				<div style="text-align: right;margin-top: 50px;">江苏国际人才咨询服务有限公司</div>
				<div style="text-align: right;">{{ new Date().getFullYear() }}年{{ new Date().getMonth() + 1 }}月{{
					new
						Date().getDate()
				}}日</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="show = false; isDyxs = true;">关 闭</el-button>
				<el-button plain @click="aaa" type="primary">打 印</el-button>
			</span>
		</el-dialog>

		<el-dialog title="修改" :visible.sync="isChange" width="30%">
			<el-form :model="form">
				<el-form-item label="租金状态">
					<el-select v-model="status" placeholder="状态" style="width: 100px;">
						<el-option label="已缴费" value="已缴费"></el-option>
						<el-option label="未缴费" value="未缴费"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="isChange = false">关 闭</el-button>
				<el-button @click="isOk" type="primary">确 定</el-button>
			</span>
		</el-dialog>
		<!-- <el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane label="查询" name="1"> -->

		<el-form :inline="true" :model="form" class="demo-form-inline">
			<div class="flex sb">
				<div>
					<el-form-item label="商铺号">
						<!-- <el-input size="small" v-model="form.shopNum" placeholder="请输入商铺号" style="width: 150px;"
							clearable></el-input> -->
						<el-select filterable size="small" v-model="form.shopNum" placeholder="请选择商铺号" clearable style="width: 150px;">
							<el-option v-for="item in shopList" :label="item.shopNum" :value="item.shopNum"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="商铺名称">
						<!-- <el-input size="small" v-model="form.shopName" placeholder="请输入商铺名称" style="width: 150px;"
							clearable></el-input> -->
						<el-select filterable size="small" v-model="form.shopName" placeholder="请选择商铺名称" clearable
							style="width: 240px;">
							<el-option v-for="item in shopList" :label="item.brandName" :value="item.brandName"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="出账年月">
						<el-date-picker size="small" value-format="yyyy-MM" type="monthrange" range-separator="至"
							start-placeholder="开始年月" end-placeholder="结束年月" v-model="queryDate"
							style="width:340px;"></el-date-picker>
					</el-form-item>

					<!-- <el-form-item label="欠费状态">
						<el-select size="small" clearable v-model="form.arrearage" placeholder="欠费状态"
							style="width: 100px;">
							<el-option size="small" label="是" value="是"></el-option>
							<el-option label="否" value="否"></el-option>
						</el-select>
					</el-form-item> -->
					<!-- <el-form-item label="复核状态">
						<el-select size="small" v-model="form.review" placeholder="复核状态" clearable style="width: 130px;">
							<el-option label="已复核" value="已复核"></el-option>
							<el-option label="未复核" value="未复核"></el-option>
						</el-select>
					</el-form-item> -->
					<el-form-item label="开票状态">
						<el-select size="small" v-model="form.kpStatus" placeholder="开票状态" clearable style="width: 130px;">
							<el-option label="已开票" value="已开票"></el-option>
							<el-option label="未开票" value="未开票"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button size="small" type="primary" @click="query">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button size="small" type="primary" @click="querySeach">重置</el-button>
					</el-form-item>
					<!-- <el-form-item>
						<el-button size="small" type="primary" @click="fuheRow">复核</el-button>
					</el-form-item> -->
					<!-- <el-form-item v-if="activeName == '1'">
						<el-button size="small" type="primary" @click="addTemplate">下载对账单导入模板</el-button>
					</el-form-item>

					<el-form-item v-if="activeName == '1'">
						<el-upload action="/api/admin/reconciliation/importReconciliation" name="file"
							:show-file-list="false" :headers="headers" :on-success="success">
							<el-button size="small" type="primary">导入对账单</el-button>
						</el-upload>
					</el-form-item> -->
					<el-form-item>
						<el-button size="small" type="primary" @click="dc">导出</el-button>
					</el-form-item>
					<el-form-item>
						<el-button size="small" type="primary" @click="dcAll">下载开票信息</el-button>
					</el-form-item>

					<!-- <el-form-item v-if="activeName == '1'">
								<el-button size="small" type="primary" @click="dc2">下载已开票信息</el-button>
							</el-form-item>
							<el-form-item v-if="activeName == '1'">
								<el-button size="small" type="primary" @click="dc3">下载未开票信息</el-button>
							</el-form-item> -->
					<el-form-item>
						<el-popover placement="bottom" width="180" v-model="show1" style="margin-bottom: 20px;">
							<el-checkbox-group v-model="checkList" @change="checkChange">
								<el-checkbox :label="val" v-for="(val, key) in oldTitleObj" :key="key"
									:disabled="val == oneRow">
								</el-checkbox>
							</el-checkbox-group>
							<!-- <el-button slot="reference" type="primary">筛选列表</el-button> -->
						</el-popover>
					</el-form-item>


				</div>

			</div>
			<div>{{ tongjiJson }}</div>
		</el-form>
		<!-- <div style="text-align: center;font-size: 18px;" v-if="activeName == '1'">
			<span style="margin-right:10px;">账单信息</span>
			<el-date-picker value-format="yyyy-MM" size="small" @change="query" v-model="queryMonth" type="month"
				placeholder="选择年月" :clearable="true">
			</el-date-picker>
		</div> -->
		<el-table :data="data" style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column label="商铺号" prop="shopNum" align="center" width="100">
			</el-table-column>
			<el-table-column label="商铺名称" prop="shopName" align="center">
			</el-table-column>
			<el-table-column label="账期时间" prop="paymentDay" align="center" width="200">
				<!-- <template slot-scope="{row}">
					<span>
						{{ row.appdate + "-01" }}</span>
				</template> -->
			</el-table-column>
			<!-- <el-table-column label="店铺余额" prop="balance" align="center">
					</el-table-column>
					<el-table-column label="应收金额" prop="total" align="center">
					<template slot-scope="{row}">
					<span>{{ row.total - row.balance }}</span>
						</template>
			</el-table-column> -->
			<el-table-column label="应收合计" prop="total" align="center">
			</el-table-column>
			<el-table-column label="租金" prop="money" align="center">
				<template slot-scope="{row}">
					{{ parseFloat(row.money).toFixed(2) }}
				</template>
			</el-table-column>
			<el-table-column prop="status" label="对账状态" align="center">
				<template slot-scope="{row}">
					<span :style="row.status == '已缴费' ? 'color:#30C25B' : 'color:red'">
						{{ row.status == '已缴费' ? '已对账' : '未对账' }}</span>
				</template>
			</el-table-column>
			<el-table-column label="物业费" prop="wuyepay" align="center">
			</el-table-column>
			<el-table-column prop="wuyeStatus" label="对账状态" align="center">
				<template slot-scope="{row}">
					<span :style="row.wuyeStatus == '1' ? 'color:#30C25B' : 'color:red'">
						{{ row.wuyeStatus == '1' ? '已对账' : '未对账' }}</span>
				</template>
			</el-table-column>
			<el-table-column label="推广费" prop="promotionSum" align="center">
			</el-table-column>
			<el-table-column prop="promotionStatus" label="对账状态" align="center">
				<template slot-scope="{row}">
					<span :style="row.promotionStatus == '1' ? 'color:#30C25B' : 'color:red'">
						{{ row.promotionStatus == '1' ? '已对账' : '未对账' }}</span>
				</template>
			</el-table-column>
			<el-table-column label="其他费用" prop="otherExpenses" align="center">
				<template slot-scope="{row}">
					<span>
						{{ row.otherExpenses }}
					</span>
				</template>
			</el-table-column>
			<el-table-column prop="otherStatus" label="对账状态" align="center">
				<template slot-scope="{row}">
					<div v-if="row.otherExpenses != 0">
						<span :style="row.otherStatus == '1' ? 'color:#30C25B' : 'color:red'">
							{{ row.otherStatus == '1' ? '已对账' : row.otherStatus == '0' ? '未对账' : '-' }}</span>
					</div>
					<div v-else>--</div>
				</template>
			</el-table-column>
			<!-- <el-table-column label="实缴金额" prop="paidInAmount" align="center">
			</el-table-column> -->
			<!-- <el-table-column label="记录1" prop="record1" align="center">
			</el-table-column>
			<el-table-column  label="记录2" prop="record2" align="center">
				
			</el-table-column>
			<el-table-column  label="记录3" prop="record3" align="center">
			
			</el-table-column>
			<el-table-column label="应收应付差额" prop="names" align="center">
				<template slot-scope="{row}">
					<span :style="row.difference > 0 ? 'color:#30C25B' : row.difference < 0 ? 'color:red' : ''">{{
						row.difference
					}}</span>
				</template>
			</el-table-column> -->
			<!-- <el-table-column label="是否欠费" align="center">
				<template slot-scope="{row}">
					<span :style="row.arrearage == '否' ? 'color:#30C25B' : 'color:red'">{{
						row.arrearage
					}}</span>
				</template>
			</el-table-column> -->
			<!-- <el-table-column label="对账状态" prop="names" align="center">
			</el-table-column> -->
			<!-- <el-table-column v-if="activeName == '1'" label="复核状态" prop="review" align="center">
				<template slot-scope="{row}">
					{{ row.review ? row.review : '未复核' }}
				</template>
			</el-table-column> -->
			<el-table-column label="开票状态" prop="kpStatus" align="center">
			</el-table-column>
			<!-- <el-table-column v-if="activeName == '1'" prop="date" label="操作" width="160" align="center">
				<template slot-scope="{row}">
					<el-button v-if="row.status == '未缴费' || row.wuyeStatus == '0' || row.promotionStatus == '0'" type="text"
						@click="setRow(row)">对账</el-button>
					<el-button :disabled="row.review == '已复核'" type="text" @click="fuheRow(row)">复核</el-button>
				</template>
			</el-table-column> -->
		</el-table>
		<el-pagination v-if="count > 0" :page-sizes="[10, 20, 30, 50]" :page-size="form.pageSize"
			:current-page="form.currentPage"
			@size-change="handleSizeChange" @current-change="handleCurrentChange"
			layout="total, sizes, prev, pager, next, jumper" :total="count">
		</el-pagination>
		<!-- </el-tab-pane>
			<el-tab-pane label="统计" name="2">
				<el-form :inline="true" :model="form" class="demo-form-inline">
					<div class="flex sb">
						<div>
							<el-form-item label="商铺号">
								<el-input size="small" v-model="form.shopNum" placeholder="请输入商铺号" style="width: 150px;"
									clearable></el-input>
							</el-form-item>
							<el-form-item label="商铺名称">
								<el-input size="small" v-model="form.shopName" placeholder="请输入商铺名称"
									style="width: 150px;" clearable></el-input>
							</el-form-item>
							<el-form-item label="出账年月">
								<el-date-picker size="small" value-format="yyyy-MM" type="monthrange"
									range-separator="至" start-placeholder="开始年月" end-placeholder="结束年月"
									v-model="queryDate" style="width:340px;"></el-date-picker>
							</el-form-item>

							<el-form-item label="欠费状态">
								<el-select size="small" clearable v-model="form.arrearage" placeholder="欠费状态"
									style="width: 100px;">
									<el-option size="small" label="是" value="是"></el-option>
									<el-option label="否" value="否"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="复核状态">
								<el-select size="small" v-model="form.review" placeholder="复核状态" clearable
									style="width: 130px;">
									<el-option label="已复核" value="已复核"></el-option>
									<el-option label="未复核" value="未复核"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item>
								<el-button size="small" type="primary" @click="getAll">查询</el-button>
							</el-form-item>
							<el-form-item>
								<el-button size="small" type="primary" @click="querySeach">重置</el-button>
							</el-form-item>
							<el-form-item>
								<el-button size="small" type="primary" @click="fuheRow">复核</el-button>
							</el-form-item>

							<el-form-item v-if="activeName == '1'">
								<el-button size="small" type="primary" @click="dc2">下载已开票信息</el-button>
							</el-form-item>
							<el-form-item v-if="activeName == '1'">
								<el-button size="small" type="primary" @click="dc3">下载未开票信息</el-button>
							</el-form-item>
							<el-form-item>
								<el-popover placement="bottom" width="180" v-model="show1" style="margin-bottom: 20px;">
									<el-checkbox-group v-model="checkList" @change="checkChange">
										<el-checkbox :label="val" v-for="(val, key) in oldTitleObj" :key="key"
											:disabled="val == oneRow">
										</el-checkbox>
									</el-checkbox-group>
								</el-popover>
							</el-form-item>

							<el-form-item>
							</el-form-item>
						</div>

					</div>
				</el-form>
				<div style="text-align: center;font-size: 18px;" v-if="activeName == '1'">
					<span style="margin-right:10px;">账单信息</span>
					<el-date-picker value-format="yyyy-MM" size="small" @change="query" v-model="queryMonth"
						type="month" placeholder="选择年月" :clearable="true">
					</el-date-picker>
				</div>
				<el-table :data="data" style="width: 100%" v-loading="loading"
					@selection-change="handleSelectionChange">
					<el-table-column label="商铺号" prop="shopNum" align="center">
					</el-table-column>
					<el-table-column label="商铺名称" prop="shopName" align="center">
					</el-table-column>
					<el-table-column label="账期时间" prop="appdate" align="center">
						<template slot-scope="{row}">
							<span>
								{{ row.appdate + "-01" }}</span>
						</template>
					</el-table-column>
					<el-table-column label="应收金额" prop="total" align="center">
					</el-table-column>
					<el-table-column label="实缴金额" prop="paidInAmount" align="center">
						<template slot-scope="{row}">
							{{ row.paidInAmount ? row.paidInAmount : '--' }}
						</template>
					</el-table-column>
					<el-table-column label="应收应付差额" prop="names" align="center">
						<template slot-scope="{row}">
							<span :style="row.difference > 0 ? 'color:#30C25B' : 'color:red'">{{
								row.difference
							}}</span>
						</template>
					</el-table-column>
					<el-table-column label="是否欠费" align="center">
						<template slot-scope="{row}">
							<span :style="row.arrearage == '否' ? 'color:#30C25B' : 'color:red'">{{
								row.arrearage
							}}</span>
						</template>
					</el-table-column>
					<el-table-column label="开票状态" prop="kpStatus" align="center">
					</el-table-column>
					<el-table-column v-if="activeName == '1'" prop="date" label="操作" width="160" align="center">
						<template slot-scope="{row}">
							<el-button v-if="row.status == '未缴费' || row.wuyeStatus == '0' || row.promotionStatus == '0'"
								type="text" @click="setRow(row)">对账</el-button>
							<el-button type="text" @click="fuheRow(row)">复核</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination v-if="count > 0" :page-sizes="[10, 20, 30, 50]" :page-size="form.pageSize"
					@size-change="handleSizeChange" @current-change="handleCurrentChange"
					layout="total, sizes, prev, pager, next, jumper" :total="count">
				</el-pagination>


			</el-tab-pane>
		</el-tabs> -->


		<el-dialog title="对账中" :visible.sync="show2" width="1000px" :close-on-click-modal="false">
			<xtdzDetail :obj="obj"></xtdzDetail>
		</el-dialog>

		<el-dialog :title="title2 + '已对账信息'" :visible.sync="show3" width="850px" :close-on-click-modal="false">
			<el-form :inline="true" :model="selectForm2" class="demo-form-inline">
				<div class="flex sb">
					<div>
						<!-- <el-form-item label="商铺号">
							<el-input v-model="selectForm2.shopNum" placeholder="商铺号" clearable></el-input>
						</el-form-item> -->

						<el-form-item label="缴费类型">
							<el-select v-model="selectForm2.type" clearable>
								<el-option label="租金" value="租金"></el-option>
								<el-option label="物业费" value="物业费"></el-option>
								<el-option label="水费" value="水费"></el-option>
								<el-option label="电费" value="电费"></el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="开始时间">
							<el-date-picker v-model="selectForm2.startTime" type="date" placeholder="开始时间"
								style="width: 150px;">
							</el-date-picker>
						</el-form-item>
						<el-form-item label="结束时间">
							<el-date-picker clearable v-model="selectForm2.endTime" type="date" placeholder="结束时间"
								style="width: 150px;">
							</el-date-picker>
						</el-form-item>
						<el-form-item label="是否已开票">
							<el-select v-model="selectForm2.isInvoice" clearable>
								<el-option label="是" value="1"></el-option>
								<el-option label="否" value="2"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="getData2()">查询</el-button>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="query2">重置</el-button>
						</el-form-item>
					</div>

				</div>
			</el-form>
			<el-table :data="data2" style="width: 100%" v-loading="loading2">

				<el-table-column prop="reconciliationNum" label="对账编号"></el-table-column>
				<el-table-column prop="name" label="商铺号"></el-table-column>
				<el-table-column prop="shopName" label="商铺名称"></el-table-column>
				<el-table-column prop="type" label="缴费类型"></el-table-column>
				<el-table-column prop="amount" label="对账金额"></el-table-column>

				<el-table-column prop="time" label="对账时间"></el-table-column>
				<el-table-column prop="person" label="对账人"></el-table-column>
				<el-table-column prop="state" label="开票状态">
					<template slot-scope="{row}">
						{{ row.kpStatus }}
					</template>
				</el-table-column>

			</el-table>
			<el-pagination :page-sizes="[10, 20, 30, 50]" :page-size="selectForm2.row" :current-page.sync="selectForm2.page"
				layout="total, sizes, prev, pager, next, jumper" :total="count2" @size-change="handleSizeChange2"
				@current-change="handleCurrentChange2">
			</el-pagination>
		</el-dialog>
	</div>
</template>

<script>
import publicExport from '../../../assets/js/publicExport.js';
import downloadFile from '../../../assets/js/downloadFile.js';
import xtdzDetail from './xtdzDetail.vue'
import { setTimeout } from 'timers';
export default {
	// 注册组件
	components: {
		xtdzDetail
	},
	data() {
		return {
			titleObj: {
				contractCode: "实缴金额",

			},
			paymentBillVos: [],
			count2: 0,
			selectForm2: {
				page: 1,
				row: 10,
				shopNum: null, //商铺号
				startTime: null,
				endTime: null,
				type: null,
				isInvoice: null
			},
			show2: false,
			show3: false,
			activeName: "1",
			queryMonth: "",
			headers: {
				Authorization: localStorage.access_token
			},
			queryDate: [],
			loading: false,
			sum: 0,
			count: 0,
			isDyxs: true,
			users: [], //申请人
			show: false,
			status: '',
			id: '',
			bdShopPayList: [],
			form: {
				"startDate": "", //开始时间
				"endDate": "", //结束时间
				"shopName": "", //商铺名称
				"shopNum": "", //商铺号
				"arrearage": "", //欠费状态
				"review": "已复核", //复核状态
				"kpStatus": "", //开票状态
				"currentPage": 1,
				"pageSize": 10,
			},
			addForm: {},
			data: [],
			obj: {
				fileRes: "",
				applyTime: ""
			}, //详情数据
			isChange: false,
			show1: false, //控制筛选列的多选框
			oneRow: "", //当checkList列表只有一项时,选择框不可点击
			checkList: ["商铺号", "商铺名称", "联系人", "联系方式", "账期时间"
				, "租金", "租金增值税9%", "租金收入", "物业费", "物业增值税6%",
				"物业费收入", "推广费", "推广增值税6%", "推广费收入", "购电费", "水费", "应缴合计"],
			titleObj: {
				shopNum: "商铺号",
				shopName: "商铺名称",
				name: "联系人",
				phone: '联系方式',
				appdate: '账期时间',
				money: "租金",
				rentalRevenue: "租金增值税9%",
				rentalIncome: "租金收入",
				wuyepay: "物业费",
				wuyeRevenue: "物业增值税6%",
				wuyeIncome: "物业费收入",
				promotionSum: "推广费",
				promotionRevenue: "推广增值税6%",
				promotionIncome: "推广费收入",
				electricPay: "购电费",
				waterPay: "水费",
				total: "应缴合计",
			},
			oldTitleObj: {
				shopNum: "商铺号",
				shopName: "商铺名称",
				name: "联系人",
				phone: '联系方式',
				appdate: '账期时间',
				money: "租金",
				rentalRevenue: "租金增值税9%",
				rentalIncome: "租金收入",
				wuyepay: "物业费",
				wuyeRevenue: "物业增值税6%",
				wuyeIncome: "物业费收入",
				promotionSum: "推广费",
				promotionRevenue: "推广增值税6%",
				promotionIncome: "推广费收入",
				electricPay: "购电费",
				waterPay: "水费",
				total: "应缴合计",
			},
			roleId: "",
			data2: [],
			dataIds: [],
			title2: "",
			loading2: false,
			shopList: [],
			tongjiJson: ""
		}
	},
	created() {
		this.setMonth2();
		this.roleId = localStorage.roleId

		this.getShopList();
		this.getAll();
		// this.getUsers();
	},
	methods: {
		getShopList() {
			let selectForm = {
				currentPage: 1,
				pageSize: 1000,
			};
			this.$http.post("/api/bdShop/queryShop", selectForm).then(res => {
				this.shopList = res.data.data.items
			})
		},
		selectable(row, rowIndex) {
			if (row.kpStatus == '已开票') {
				return true;  //不禁用
			} else {
				return false;  //禁用
			}
		},
		handleSelectionChange(val) {
			this.paymentBillVos = val
			var ids = []
			val.forEach(row => {
				if (row.review == '未复核' && row.status == '已缴费' && row.wuyeStatus == '1' && row.promotionStatus == '1') {
					ids.push(row.id)
				}
			});
			this.dataIds = ids
		},
		handleCurrentChange2(val) {
			this.selectForm2.page = val;
			this.getData2()
		},
		handleSizeChange2(val) {
			this.selectForm2.row = val;
			this.getData2()
		},
		setRowInfo(obj) {
			this.data2 = [];
			this.selectForm2.shopNum = obj.shopNum
			this.title2 = obj.name
			this.query2();
			this.show3 = true;

		},
		query2() {
			this.selectForm2.page = 1;
			this.selectForm2.row = 10;
			this.selectForm2.startTime = null;
			this.selectForm2.endTime = null;
			this.selectForm2.type = null;
			this.selectForm2.isInvoice = null;
			this.getData2();
		},
		getData2() {
			this.loading2 = true;
			this.$http.post("/api/reconciliation/reconciliationList", this.selectForm2).then(res => {
				this.loading2 = false;
				this.data2 = res.data.data.items
				this.count2 = res.data.data.totalNum
			})
		},
		setRow(obj) {
			this.obj = obj;
			this.show2 = true;
		},
		setMonth2() {
			let year = new Date().getFullYear()
			let mon = new Date().getMonth() + 1
			// mon = mon - 1
			if (mon <= 0) {
				year = year - 1
				mon = mon + 12
			}
			if (mon < 10) {
				mon = '0' + mon
			}
			let queryMonth = year + '-' + mon;
			this.queryDate = [queryMonth, queryMonth]
		},
		setMonth() {
			let year = new Date().getFullYear()
			let mon = new Date().getMonth() + 1
			// mon = mon - 1
			if (mon <= 0) {
				year = year - 1
				mon = mon + 12
			}
			if (mon < 10) {
				mon = '0' + mon
			}
			this.queryMonth = year + '-' + mon;
		},
		handleClick() {
			if (this.activeName == '1') {
				this.setMonth();
				this.queryDate = [];
			} else {
				this.setMonth2();
				this.queryMonth = "";
			}
			this.getAll()
		},
		success(res) {
			if (res.code == 0) {
				this.getAll()
				this.$message.success("导入成功")
			} else {
				this.$message.error(res.message)
			}
		},
		addTemplate() { //下载导入模板
			this.$http.post(`/api/reconciliation/downloadReconciliationTemplate`, {}, {
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=utf-8",
				},
				responseType: "blob"
			}).then(res => {
				const link = document.createElement("a");
				let blob = new Blob([res.data], {
					type: "application/vnd.ms-excel"
				});
				link.style.display = "none";
				link.href = URL.createObjectURL(blob);
				link.download = "对账单导入模板.xls";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			})
		},
		dc() {
			if (this.queryDate && this.queryDate.length == 2) {
				this.form.startDate = this.queryDate[0]
				this.form.endDate = this.queryDate[1]
				this.queryMonth = ""
			} else {
				this.form.startDate = ""
				this.form.endDate = ""
			}
			publicExport("/api/bdShop/exportShopPay", this.form, "对账信息")
		},
		dcAll() {
			// if (this.form.kpStatus == "") {
			// 	this.$message.warning("请选择开票状态！")
			// 	return
			// }
			this.dc2();

		},
		dc2() {
			let ids = []
			this.paymentBillVos.forEach(element => {
				if (element.kpStatus != "不可开票") {
					ids.push(element.id)
				}
			});
			if (ids.length == 0) {
				this.$message.error("选中数据暂无可下载开票信息！")
				return
			}
			this.getData2();
			publicExport("/api/reconciliation/exportInvoice", { ids: ids.toString() }, "历史开票信息")
		},
		editShopPay(row, index) {
			this.bdShopPayList[index].editIs = "1";
		},
		saveShopPay(row, index) {
			if (row.money === '') {
				this.$message.error("请输入金额")
				return;
			}
			let data = {
				list: [
					{
						money: row.money,
						type: row.type
					}
				],
				shopNum: this.obj.shopNum,
				time: row.appdate,
			}
			this.$http.post("/api/shopPay/update", data).then(res => {
				if (res.data.code == 0) {
					this.$message.success(res.data.data)
					this.bdShopPayList[index].editIs = "0";
					this.getAll();
				} else {
					this.$message.error(res.data.data)
				}

			})

		},
		aaa() {
			// if (1 == 1) {
			//     this.$message.error("水电费为空，无法打印！")
			//     return false;
			// }
			this.isDyxs = false;
			setTimeout(r => {
				this.$print(this.$refs.print)
			}, 1000)

		},
		checkChange(val) { //筛选列复选框被改变
			console.log(val)
			// val.forEach(val=>{
			// 	if(val=='')
			// })
			var newObj = {}
			for (var key in this.oldTitleObj) {
				if (val.indexOf(this.oldTitleObj[key]) != -1) {
					newObj[key] = this.oldTitleObj[key]
				}
			}
			this.titleObj = newObj;
			if (val.length == 1) { //只有一列时,复选框禁止勾选
				this.oneRow = val[0];
				this.$message.warning("表格内容至少显示一列")
				return;
			}
			this.oneRow = ""
		},

		handleClose() {
			this.show = false
			this.isDyxs = true
		},
		downFil(item) {
			downloadFile(item)
		},
		changeRow(obj) {
			this.id = obj.id
			this.status = obj.status
			this.isChange = true
		},
		isOk() {
			this.$http.post("/api/shopPay/updateShopPay", {
				id: this.id,
				status: this.status
			}).then(res => {
				if (res.data.code == 0) {
					this.$message.success(res.data.message)
					this.isChange = false
					this.getAll()
				}
				console.log(res)

			})
		},
		lookRow(obj) {
			this.sum = 0;
			this.$http.get(`/api/shopPay/selectOne?id=${obj.id}`).then(res => {
				if (res.data.code == 0) {
					this.obj = res.data.data
					res.data.data.bdShopPayList.forEach(val => {
						val.editIs = "0"
						this.sum = Math.floor(val.money * 100) / 100 + this.sum
					})
					this.bdShopPayList = JSON.parse(JSON.stringify(res.data.data.bdShopPayList))
					this.show = true;
				} else {
					this.$message.error("查询失败！")
				}
			})
		},
		fuheRow(row) {
			if (row.id) {
				this.dataIds = [];
				if (row.review == '未复核' && row.status == '已缴费' && row.wuyeStatus == '1' && row.promotionStatus == '1') {
					this.dataIds.push(row.id)
				}
			}
			if (this.dataIds.length == 0) {
				this.$message({
					type: 'warning',
					message: '选中的数据暂不可复核！'
				});
				return
			}
			const id = this.dataIds.toString();
			this.$confirm('是否确认复核?', "警告", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				this.$http.post(`/api/shopPay/review`, { ids: id, review: '已复核' }).then(res => {
					this.getAll();
					this.$message.success("复核成功");
				})
				// return delDeployment(ids);
			}).catch(() => {
				this.$message({
					type: 'warning',
					message: '已取消复核'
				});
			});
		},
		handleCurrentChange(val) {
			this.form.currentPage = val;
			this.getAll()
		},
		handleSizeChange(val) {
			this.form.pageSize = val;
			this.getAll()
		},
		getUsers() { //查询申请人
			this.$http.get("/api/bdShopRenovation/getUserShop").then(res => {
				this.users = res.data.data
			})
		},
		querySeach() {
			this.queryDate = [];
			this.setMonth();
			this.form = {
				"startDate": "", //开始时间
				"endDate": "", //结束时间
				"shopName": "", //商铺名称
				"shopNum": "", //商铺号
				"arrearage": "", //欠费状态
				"review": "已复核", //复核状态
				"currentPage": 1,
				"pageSize": 10,
			};
			this.getAll();
		},
		query() {
			this.form.currentPage = 1;
			this.getAll();
		},
		getAll() { //获取表格数据
			if (this.queryDate && this.queryDate.length == 2) {
				this.form.startDate = this.queryDate[0]
				this.form.endDate = this.queryDate[1]
			} else {
				this.form.startDate = ""
				this.form.endDate = ""

			}
			this.loading = true;
			this.$http.post("/api/shopPay/queryShopPay", this.form).then(res => {
				this.loading = false;
				if (res.data.code == 0) {
					this.count = res.data.data.totalNum;
					this.data = res.data.data.items
					this.tongjiJson = res.data.data.tongjiJson
				}
			})
		},
	},

}
</script>

<style scoped="scoped">
.box {
	font-size: 16px;
	width: 70%;
}

.box>div {
	margin-bottom: 10px;
}
</style>
